export const DEFAULT_LANGUAGE = 'es';
export const FALLBACK_LANGUAGE = 'es';

export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    language: 'English'
  },
  {
    code: 'es',
    language: 'Español'
  },
  {
    code: 'pt_BR',
    language: 'Português - Brazil'
  },
  {
    code: 'pt_PT',
    language: 'Português - Portugal'
  },
  {
    code: 'de',
    language: 'Deutsch'
  },
  {
    code: 'ar',
    language: 'Arabic'
  }
];
